import { render } from "./QuranProgramCard.vue?vue&type=template&id=d32085bc&scoped=true"
import script from "./QuranProgramCard.vue?vue&type=script&lang=js"
export * from "./QuranProgramCard.vue?vue&type=script&lang=js"

import "./QuranProgramCard.vue?vue&type=style&index=0&id=d32085bc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d32085bc"]])

export default __exports__